import classnames from 'classnames';
import { QA_MATCH_CENTRE_HEADER } from '@test-config/testIds';
import { AblyComponent } from '@stadionhq-v3/ably';
import {
  AblyData,
  matchHeaderAblyMutator,
  MatchHeaderLiveProps,
} from '@utils/transforms/components/live/matchHeader.transform';
import { MatchHeaderCombined } from '@components/organisms/match-header-combined';
import styles from './matchCentreHeader.module.scss';
import { MatchCentreHeaderProps } from './matchCentreHeader.types';

const MatchCentreHeader = ({
  testId = QA_MATCH_CENTRE_HEADER.COMPONENT,
  classNames = [],
  nativeProps = {},
  matchHeader,
  locale,
  ...ablyProps
}: MatchCentreHeaderProps) => {
  const classes = classnames([styles.matchCentreHeader], classNames);

  return ablyProps ? (
    <AblyComponent<MatchHeaderLiveProps, AblyData>
      {...ablyProps}
      storeKey="Match Header"
      mutator={matchHeaderAblyMutator(matchHeader)}
      render={(liveProps: MatchHeaderLiveProps) => (
        <MatchHeaderCombined
          {...nativeProps}
          classNames={[classes]}
          data-testid={testId}
          matchHeaderProps={{
            ...matchHeader,
            ...liveProps,
            home: {
              ...matchHeader?.home,
              ...liveProps?.home,
              score: liveProps?.home.score ?? 0,
            },
            away: {
              ...matchHeader?.away,
              ...liveProps?.away,
              score: liveProps?.away.score ?? 0,
            },
          }}
          locale={locale}
        />
      )}
    />
  ) : (
    <></>
  );
};

export default MatchCentreHeader;
